var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-logo"},[_c('div',{staticClass:"login-logo__image"},[_c('img',{attrs:{"src":"/img/logo-tanasoft.svg"}})])])}]

export { render, staticRenderFns }